import type { ReduxStore } from '@st/redux'
import { Effect } from 'effect'

type DevStoresRegistry = Record<string, unknown>
type DevGlobal = typeof globalThis & { __stores__?: DevStoresRegistry }

/** Scoped dev-only store exposure for console and browser QA introspection. */
export function installDevStore(name: string, store: ReduxStore) {
  if (!import.meta.env.DEV) return Effect.void

  return Effect.acquireRelease(
    Effect.sync(() => {
      const global = globalThis as DevGlobal
      const stores = (global.__stores__ ??= {})
      stores[name] = store
      return stores
    }),
    (stores) =>
      Effect.sync(() => {
        if (stores[name] == store) {
          delete stores[name]
        }
      })
  ).pipe(Effect.asVoid)
}
